import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import {
  getUser,
  handleServerValidations,
  setLocalKey,
  blockInvalidChar,
  DT,
} from "../../../../utils/commonfunction";
import { useSelector } from "react-redux";
import * as userServices from "../../services/user.service";
import { SWAL_SETTINGS, EMAIL_REGEX, INPUT_LENGTH_15, ROLE, PHONE_NO_LENGTH } from "../../../../utils/Constants";
// import PhoneInput from 'react-phone-input-2'
import "react-phone-input-2/lib/style.css";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import PhoneInput from "../../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../../utils/CommonValidatiobn";
import CustomError from "../../../../utils/customError";
import { addProfileData } from "../../../../redux/slices/profileslice";
import { useDispatch } from "react-redux";
import { setAuth } from "../../../../redux/slices/authSlice"; 
// import 'react-phone-number-input/style.css'

const EditProfile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const showprofile = useSelector((state) => state.profile);
  const [showdefault, setShowDefault] = useState({});
  const [updateData, setUpdateData] = useState("false");
  const [submitted, setSubmitted] = useState(false);
  const Dispatch = useDispatch();

  useEffect(() => {
    const getuser = getUser("admin_user");
    setShowDefault(getuser);
  }, [updateData]);

  // console.log("showdefault", showdefault);

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(t("label_first_name_error"))
      .max(INPUT_LENGTH_15,DT(t("validation_max_input_characters"), [INPUT_LENGTH_15]))
      .matches(/^[A-Za-z\s]+$/, t("label_first_name_format_error")),
    email: Yup.string()
    .trim()
    .email("Invalid email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[A-Za-z0-9-]+\.[A-Za-z]{2,63}$/,
      "Please enter a valid email address"
    )
    .required("Email is required"),
    files: Yup.mixed()
      .required(t("label_image_error"))
      .test("fileType", t("label_image_format_error"), (value) => {
        if (!value) {
          const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
          return supportedFormats.includes(value.type);
        } else {
          return true;
        }
      }),
      phone_number: PHONE_VALIDATION,
  });

 

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name:
        showdefault && showdefault.name ? showdefault.name : "",
      email: showdefault && showdefault.email ? showdefault.email : "",
      files:
        showdefault && showdefault.profile_image
          ? showdefault.profile_image
          : "",
      phone_number:
        showdefault &&
        showdefault.phone_number &&
        showdefault.phone_number
          ? showdefault.phone_number
          : "",
    },
    validationSchema: validationSchema,
    validateOnBlur: false,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      setSubmitted(true);
      let formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("phone_number", values.phone_number);
  

      if (showprofile && showprofile.file) {
        formData.append('image', showprofile.file);
      }

      userServices
        .updateProfileUsers(formData)
        .then((response) => {
          setSubmitted(false);
          if (response.success) {
            setLocalKey("admin_user", JSON.stringify(response.data));
            Dispatch(addProfileData(response.data));
            Dispatch(setAuth(response.data));
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm({ values: "" });
            setUpdateData(!updateData);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setSubmitted(false);
          console.log("error ====> ", error);
        });
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="mt-5">
              <div className="form-group ">
                <div className="row row-sm">
                  <div className="col-md-4">
                    <label className="text-left d-flex" htmlFor="Email">
                      {t("label_name")}:<span className="requirestar">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      placeholder={t("placeholder_name")}
                    />
                    <span className="text-danger d-flex text-left">
                      {formik.errors.name &&
                        formik.touched.name &&
                        formik.errors.name}
                    </span>
                  </div>
                </div>
              </div>


              <div className="form-group ">
                <div className="row row-sm">
                  <div className="col-md-4">
                    <label className="text-left d-flex" htmlFor="email">
                    {t("label_email")}:<span className="requirestar">*</span>
                    </label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder={t("placeholder_email")}
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      autoComplete="off"
                    />
                    <span className="text-danger d-flex text-left">
                      {formik.errors.email &&
                        formik.touched.email &&
                        formik.errors.email}
                    </span>
                  </div>
                </div>
              </div>
              <div className="form-group ">
                <div className="row row-sm">
                  <div className="col-md-4">
                    <label className="text-left d-flex" htmlFor="phone_number">
                    {t("label_phone_number")}:
                    </label>
              
                              <PhoneInput
                        value={formik?.values?.phone_number}
                        name={'phone_number'} onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }} onBlur={formik.handleBlur} />
                    <CustomError name="phone_number" form={formik} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <button
                  className="btn btn-info mr-2"
                  type="submit"
                  disabled={submitted ? true : null}
                >
                  <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                  {t("btn_submit")}
                </button>
                <button
                  className="btn ripple btn-secondary"
                  type="button"
                  disabled={submitted ? true : null}
                  onClick={() => {navigate(-1)}}
                >
                  <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                  {t("btn_cancel")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default EditProfile;
